

// // client/src/pages/payment/PaymentUploadPage.jsx

// import React, { useEffect, useRef, useState } from "react";
// import { uploadPayments } from "../../api/paymentApi";
// import PaymentUploader from "../../components/payment/PaymentUploader";

// export default function PaymentUploadPage() {

//   const [file, setFile]               = useState(null);
//   const [result, setResult]           = useState(null);
//   const [loading, setLoading]         = useState(false);
//   const [uploaderKey, setUploaderKey] = useState(0);
//   const [showAlreadyPaid, setShowAlreadyPaid] = useState(false);
//   const [showNotFound, setShowNotFound]       = useState(false);

//   const [hidden, setHidden]     = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const lastY = useRef(0);

//   useEffect(() => {
//     const onScroll = () => {
//       const y = window.scrollY;
//       setScrolled(y > 8);
//       if (y > lastY.current && y > 120) setHidden(true);
//       else setHidden(false);
//       lastY.current = y;
//     };
//     window.addEventListener("scroll", onScroll, { passive: true });
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   const handleProcess = async () => {
//     if (!file) { alert("Please select a payment Excel file."); return; }
//     try {
//       setLoading(true);
//       setShowAlreadyPaid(false);
//       setShowNotFound(false);
//       const response = await uploadPayments(file);

//       // ── FALLBACK: backend still returns old flat errors[] array ──────
//       // Derive typed buckets so breakdown panels work with both backends.
//       if (!response.alreadyPaidInvoices && Array.isArray(response.errors)) {
//         response.alreadyPaidInvoices = response.errors
//           .filter((e) => e.reason === "Invoice already paid")
//           .map((e) => ({ invoice_number: e.invoice_number, vendor: e.vendor || null, amount: e.amount || null }));
//       }
//       if (!response.notFoundInvoices && Array.isArray(response.errors)) {
//         response.notFoundInvoices = response.errors
//           .filter((e) => e.reason === "Invoice not found")
//           .map((e) => ({ invoice_number: e.invoice_number, vendor: e.vendor || null, amount: e.amount || null }));
//       }
//       if (response.alreadyPaid === undefined)
//         response.alreadyPaid = response.alreadyPaidInvoices?.length || 0;
//       if (response.notFound === undefined)
//         response.notFound = response.notFoundInvoices?.length || 0;
//       // ─────────────────────────────────────────────────────────────────

//       setResult(response);
//     } catch (err) {
//       console.error("Payment processing error:", err);
//       alert("Payment processing failed.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleReset = () => {
//     setResult(null);
//     setFile(null);
//     setShowAlreadyPaid(false);
//     setShowNotFound(false);
//     setUploaderKey((k) => k + 1);
//   };

//   return (
//     <div style={styles.page}>

//       {/* ── HEADER ── */}
//       <header style={{
//         ...styles.header,
//         ...(scrolled ? styles.headerScrolled : {}),
//         ...(hidden   ? styles.headerHidden   : {}),
//       }}>
//         <div style={styles.headerInner}>
//           <div style={styles.brand}>
//             <div style={styles.logoWrap}>📤</div>
//             <div>
//               <div style={styles.brandTitle}>Upload Payments</div>
//               <div style={styles.brandSubtitle}>Process and update invoice payment records</div>
//             </div>
//           </div>
//         </div>
//       </header>

//       {/* ── MAIN ── */}
//       <main style={styles.main}>

//         <div style={styles.pageHeader}>
//           <div style={styles.eyebrowRow}>
//             <span style={styles.eyebrowDot} />
//             <span style={styles.eyebrow}>Payments</span>
//             <span style={styles.eyebrowSep}>/</span>
//             <span style={styles.eyebrowMuted}>Upload</span>
//           </div>
//           <h1 style={styles.pageTitle}>Payment Upload</h1>
//           <p style={styles.pageSubtitle}>
//             Upload an Excel sheet to process and update invoice payment records in the database
//           </p>
//         </div>

//         <div style={styles.contentGrid}>

//           {/* ── LEFT ── */}
//           <PaymentUploader
//             key={uploaderKey}
//             file={file}
//             setFile={setFile}
//             onProcess={handleProcess}
//             loading={loading}
//           />

//           {/* ── RIGHT ── */}
//           <div style={styles.sectionCard}>
//             {result ? (
//               <>
//                 {/* ── RESULT HEADER ── */}
//                 <div style={styles.sectionHeader}>
//                   <div style={{ ...styles.sectionIconWrap, backgroundColor: "#dcfce7" }}>
//                     <span style={styles.sectionIcon}>✅</span>
//                   </div>
//                   <div>
//                     <div style={styles.sectionTitle}>Processing Complete</div>
//                     <div style={styles.sectionSubtitle}>
//                       {result.totalRows} row{result.totalRows !== 1 ? "s" : ""} processed from file
//                     </div>
//                   </div>
//                 </div>

//                 <div style={styles.divider} />

//                 {/* ── STAT BOXES ── */}
//                 <div style={styles.resultGrid}>
//                   <StatBox value={result.totalRows}       label="Total Rows" />
//                   <StatBox value={result.updatedInvoices} label="Updated"      valueColor="#15803d" bg="#f0fdf4" border="#bbf7d0" />
//                   <StatBox
//                     value={result.alreadyPaid}
//                     label="Already Paid"
//                     valueColor="#b45309"
//                     bg="#fffbeb"
//                     border="#fde68a"
//                     clickable={result.alreadyPaid > 0}
//                     expanded={showAlreadyPaid}
//                     onToggle={() => setShowAlreadyPaid((v) => !v)}
//                   />
//                   <StatBox
//                     value={result.notFound}
//                     label="Not Found"
//                     valueColor="#dc2626"
//                     bg="#fef2f2"
//                     border="#fecaca"
//                     clickable={result.notFound > 0}
//                     expanded={showNotFound}
//                     onToggle={() => setShowNotFound((v) => !v)}
//                   />
//                 </div>

//                 {/* ── ALREADY PAID BREAKDOWN ── */}
//                 {showAlreadyPaid && result.alreadyPaidInvoices?.length > 0 && (
//                   <InvoiceBreakdown
//                     title="Already Paid Invoices"
//                     hint="These invoices were skipped — payment already recorded"
//                     items={result.alreadyPaidInvoices}
//                     accentColor="#b45309"
//                     accentBg="#fffbeb"
//                     accentBorder="#fde68a"
//                     dotColor="#f59e0b"
//                     tagBg="#fef3c7"
//                     tagColor="#92400e"
//                     tagLabel="Already Paid"
//                   />
//                 )}

//                 {/* ── NOT FOUND BREAKDOWN ── */}
//                 {showNotFound && result.notFoundInvoices?.length > 0 && (
//                   <InvoiceBreakdown
//                     title="Not Found Invoices"
//                     hint="These invoice numbers were not matched in the database"
//                     items={result.notFoundInvoices}
//                     accentColor="#dc2626"
//                     accentBg="#fef2f2"
//                     accentBorder="#fecaca"
//                     dotColor="#ef4444"
//                     tagBg="#fee2e2"
//                     tagColor="#991b1b"
//                     tagLabel="Not Found"
//                   />
//                 )}

//                 {/* ── MISMATCH WARNING ── */}
//                 {result.mismatch > 0 && (
//                   <div style={styles.mismatchRow}>
//                     <span style={styles.mismatchBadge}>
//                       ⚠️ {result.mismatch} mismatch{result.mismatch !== 1 ? "es" : ""} detected
//                     </span>
//                     <span style={styles.mismatchHint}>Check invoice date, service period or amount</span>
//                   </div>
//                 )}

//                 <div style={styles.divider} />

//                 <button style={styles.resetButton} onClick={handleReset}>
//                   ← Upload Another File
//                 </button>
//               </>
//             ) : (
//               <>
//                 <div style={styles.sectionHeader}>
//                   <div style={{ ...styles.sectionIconWrap, backgroundColor: "#f5f3ff" }}>
//                     <span style={styles.sectionIcon}>ℹ️</span>
//                   </div>
//                   <div>
//                     <div style={styles.sectionTitle}>How It Works</div>
//                     <div style={styles.sectionSubtitle}>What happens when you upload a file</div>
//                   </div>
//                 </div>

//                 <div style={styles.divider} />

//                 <div style={styles.stepList}>
//                   <Step n="1" title="File is read row by row"   desc="Each row is parsed for invoice number, date, amount and payment details" />
//                   <Step n="2" title="Matched against database"  desc="Invoice number is looked up and details are verified before any update" />
//                   <Step n="3" title="Payment record is saved"   desc="Payment date, reference number and status are updated in the database" />
//                   <Step n="4" title="Summary is returned"       desc="You see how many records were updated, skipped or not found" />
//                 </div>

//                 <div style={styles.formatNote}>
//                   <span style={styles.formatDot} />
//                   Supported formats:{" "}
//                   <strong style={{ color: "#374151" }}>.xlsx</strong> and{" "}
//                   <strong style={{ color: "#374151" }}>.xls</strong>
//                 </div>
//               </>
//             )}
//           </div>

//         </div>
//       </main>
//     </div>
//   );
// }

// // ─────────────────────────────────────
// // INVOICE BREAKDOWN PANEL
// // ─────────────────────────────────────
// function InvoiceBreakdown({
//   title, hint, items,
//   accentBg, accentBorder, accentColor,
//   dotColor, tagBg, tagColor, tagLabel,
// }) {
//   return (
//     <div style={{
//       ...styles.breakdownWrap,
//       backgroundColor: accentBg,
//       borderColor: accentBorder,
//     }}>
//       {/* Panel header */}
//       <div style={styles.breakdownHeader}>
//         <div style={styles.breakdownTitleRow}>
//           <span style={{ ...styles.breakdownDot, backgroundColor: dotColor }} />
//           <span style={{ ...styles.breakdownTitle, color: accentColor }}>{title}</span>
//           <span style={{
//             ...styles.breakdownCount,
//             backgroundColor: tagBg,
//             color: tagColor,
//             borderColor: accentBorder,
//           }}>
//             {items.length}
//           </span>
//         </div>
//         <div style={styles.breakdownHint}>{hint}</div>
//       </div>

//       {/* Invoice list */}
//       <div style={styles.breakdownList}>
//         {items.map((inv, i) => {
//           // backend may return a string (invoice number) or an object
//           const invoiceNo = typeof inv === "string" ? inv : (inv.invoice_number || inv.invoiceNumber || JSON.stringify(inv));
//           const vendor    = typeof inv === "object" ? (inv.vendor || null) : null;
//           const amount    = typeof inv === "object" ? (inv.amount || inv.invoice_amount || null) : null;

//           return (
//             <div key={i} style={styles.breakdownRow}>
//               <div style={styles.breakdownRowLeft}>
//                 <span style={{ ...styles.invoiceNumChip, borderColor: accentBorder, color: accentColor, backgroundColor: "#fff" }}>
//                   {invoiceNo}
//                 </span>
//                 {vendor && <span style={styles.vendorChip}>{vendor}</span>}
//               </div>
//               <div style={styles.breakdownRowRight}>
//                 {amount && <span style={styles.amountText}>₹{Number(amount).toLocaleString("en-IN")}</span>}
//                 <span style={{
//                   ...styles.statusTag,
//                   backgroundColor: tagBg,
//                   color: tagColor,
//                 }}>
//                   {tagLabel}
//                 </span>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

// // ─────────────────────────────────────
// // STAT BOX
// // ─────────────────────────────────────
// function StatBox({
//   value, label,
//   valueColor = "#111827",
//   bg = "#f9fafb",
//   border = "#f3f4f6",
//   clickable = false,
//   expanded = false,
//   onToggle,
// }) {
//   return (
//     <div
//       style={{
//         ...styles.resultItem,
//         backgroundColor: bg,
//         borderColor: border,
//         cursor: clickable ? "pointer" : "default",
//         position: "relative",
//       }}
//       onClick={clickable ? onToggle : undefined}
//     >
//       <span style={{ ...styles.resultValue, color: valueColor }}>{value}</span>
//       <span style={styles.resultLabel}>{label}</span>
//       {clickable && value > 0 && (
//         <span style={{
//           ...styles.resultToggle,
//           color: valueColor,
//         }}>
//           {expanded ? "▲ Hide" : "▼ View details"}
//         </span>
//       )}
//     </div>
//   );
// }

// // ─────────────────────────────────────
// // STEP
// // ─────────────────────────────────────
// function Step({ n, title, desc }) {
//   return (
//     <div style={styles.stepItem}>
//       <div style={styles.stepNumber}>{n}</div>
//       <div style={styles.stepContent}>
//         <div style={styles.stepTitle}>{title}</div>
//         <div style={styles.stepDesc}>{desc}</div>
//       </div>
//     </div>
//   );
// }

// // ─────────────────────────────────────
// // STYLES
// // ─────────────────────────────────────
// const styles = {

//   page: {
//     minHeight: "100vh",
//     backgroundColor: "#f9fafb",
//     fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//   },

//   header: {
//     position: "fixed",
//     top: 0, left: 0, right: 0,
//     height: "56px",
//     backgroundColor: "#0f172a",
//     zIndex: 100,
//     transition: "transform 0.25s ease, box-shadow 0.25s ease",
//     display: "flex",
//     alignItems: "center",
//   },
//   headerScrolled: { boxShadow: "0 1px 0 rgba(255,255,255,0.06)" },
//   headerHidden:   { transform: "translateY(-100%)" },
//   headerInner: {
//     width: "100%", maxWidth: "1400px",
//     margin: "0 auto", padding: "0 40px",
//     display: "flex", alignItems: "center",
//     justifyContent: "space-between", boxSizing: "border-box",
//   },
//   brand:         { display: "flex", alignItems: "center", gap: "12px" },
//   logoWrap: {
//     fontSize: "20px", width: "36px", height: "36px",
//     backgroundColor: "rgba(255,255,255,0.08)",
//     borderRadius: "8px",
//     display: "flex", alignItems: "center", justifyContent: "center",
//   },
//   brandTitle:    { fontSize: "14px", fontWeight: "700", color: "#ffffff", letterSpacing: "-0.01em" },
//   brandSubtitle: { fontSize: "11px", color: "rgba(255,255,255,0.45)", fontWeight: "400", marginTop: "1px" },

//   main: {
//     paddingTop: "80px", paddingBottom: "60px",
//     paddingLeft: "40px", paddingRight: "40px",
//     maxWidth: "1400px", margin: "0 auto",
//     boxSizing: "border-box", width: "100%",
//   },

//   pageHeader:   { marginBottom: "28px" },
//   eyebrowRow:   { display: "flex", alignItems: "center", gap: "7px", marginBottom: "10px" },
//   eyebrowDot:   { width: "6px", height: "6px", borderRadius: "50%", backgroundColor: "#6366f1", boxShadow: "0 0 0 3px rgba(99,102,241,0.15)" },
//   eyebrow:      { fontSize: "11px", fontWeight: "700", color: "#4f46e5", letterSpacing: "0.07em", textTransform: "uppercase" },
//   eyebrowSep:   { fontSize: "11px", color: "#d1d5db" },
//   eyebrowMuted: { fontSize: "11px", fontWeight: "600", color: "#9ca3af", letterSpacing: "0.07em", textTransform: "uppercase" },
//   pageTitle:    { fontSize: "18px", fontWeight: "700", color: "#111827", margin: 0, letterSpacing: "-0.01em" },
//   pageSubtitle: { fontSize: "13px", color: "#6b7280", margin: "4px 0 0 0", fontWeight: "400" },

//   contentGrid: {
//     display: "grid",
//     gridTemplateColumns: "1fr 1fr",
//     gap: "24px",
//     width: "100%",
//     alignItems: "stretch",
//   },

//   sectionCard: {
//     backgroundColor: "#ffffff",
//     border: "1px solid #e5e7eb",
//     borderRadius: "10px",
//     padding: "24px",
//     display: "flex",
//     flexDirection: "column",
//     gap: "20px",
//     boxSizing: "border-box",
//     height: "100%",
//   },

//   sectionHeader:   { display: "flex", alignItems: "center", gap: "14px" },
//   sectionIconWrap: { width: "40px", height: "40px", borderRadius: "8px", backgroundColor: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
//   sectionIcon:     { fontSize: "18px" },
//   sectionTitle:    { fontSize: "14px", fontWeight: "700", color: "#111827", letterSpacing: "-0.01em" },
//   sectionSubtitle: { fontSize: "12px", color: "#9ca3af", marginTop: "2px", fontWeight: "400" },

//   divider: { height: "1px", backgroundColor: "#f3f4f6", margin: "0 -24px" },

//   // ── STAT BOXES ──
//   resultGrid:    { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "12px" },
//   resultItem:    { display: "flex", flexDirection: "column", gap: "4px", padding: "16px", borderRadius: "8px", border: "1px solid #f3f4f6", transition: "box-shadow 0.15s" },
//   resultValue:   { fontSize: "28px", fontWeight: "700", color: "#111827", letterSpacing: "-0.02em", lineHeight: 1 },
//   resultLabel:   { fontSize: "11px", fontWeight: "600", color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.05em", marginTop: "4px" },
//   resultToggle:  { fontSize: "10px", fontWeight: "700", marginTop: "6px", letterSpacing: "0.02em", opacity: 0.7 },

//   // ── BREAKDOWN PANEL ──
//   breakdownWrap: {
//     border: "1px solid",
//     borderRadius: "8px",
//     overflow: "hidden",
//   },
//   breakdownHeader: {
//     padding: "12px 14px 10px",
//     borderBottom: "1px solid rgba(0,0,0,0.06)",
//   },
//   breakdownTitleRow: { display: "flex", alignItems: "center", gap: "8px", marginBottom: "3px" },
//   breakdownDot:      { width: "7px", height: "7px", borderRadius: "50%", flexShrink: 0 },
//   breakdownTitle:    { fontSize: "13px", fontWeight: "700", letterSpacing: "-0.01em" },
//   breakdownCount: {
//     fontSize: "10px", fontWeight: "700",
//     padding: "2px 7px", borderRadius: "999px",
//     border: "1px solid", marginLeft: "2px",
//   },
//   breakdownHint: { fontSize: "11px", color: "#9ca3af", fontWeight: "400" },

//   breakdownList: {
//     display: "flex",
//     flexDirection: "column",
//     maxHeight: "220px",
//     overflowY: "auto",
//     scrollBehavior: "smooth",
//   },
//   breakdownRow: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     gap: "12px",
//     padding: "9px 14px",
//     borderBottom: "1px solid rgba(0,0,0,0.04)",
//     backgroundColor: "#ffffff",
//   },
//   breakdownRowLeft:  { display: "flex", alignItems: "center", gap: "8px", minWidth: 0 },
//   breakdownRowRight: { display: "flex", alignItems: "center", gap: "8px", flexShrink: 0 },

//   invoiceNumChip: {
//     fontFamily: "ui-monospace, 'SF Mono', Menlo, monospace",
//     fontSize: "12px", fontWeight: "600",
//     padding: "2px 8px",
//     borderRadius: "4px",
//     border: "1px solid",
//     whiteSpace: "nowrap",
//   },
//   vendorChip: {
//     fontSize: "11px", fontWeight: "600",
//     color: "#6b7280", backgroundColor: "#f3f4f6",
//     padding: "2px 7px", borderRadius: "4px",
//     maxWidth: "120px", overflow: "hidden",
//     textOverflow: "ellipsis", whiteSpace: "nowrap",
//   },
//   amountText: {
//     fontSize: "12px", fontWeight: "600",
//     color: "#374151",
//     fontFamily: "ui-monospace, 'SF Mono', Menlo, monospace",
//   },
//   statusTag: {
//     fontSize: "10px", fontWeight: "700",
//     padding: "2px 8px", borderRadius: "999px",
//     letterSpacing: "0.03em",
//     whiteSpace: "nowrap",
//   },

//   mismatchRow:   { display: "flex", alignItems: "center", gap: "10px", padding: "10px 14px", backgroundColor: "#fffbeb", border: "1px solid #fde68a", borderRadius: "6px" },
//   mismatchBadge: { fontSize: "12px", fontWeight: "600", color: "#b45309", whiteSpace: "nowrap" },
//   mismatchHint:  { fontSize: "12px", color: "#92400e", fontWeight: "400" },

//   resetButton: { height: "34px", padding: "0 16px", fontSize: "12px", fontWeight: "600", color: "#374151", backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "6px", cursor: "pointer", alignSelf: "flex-start", transition: "background-color 0.15s" },

//   stepList:    { display: "flex", flexDirection: "column", gap: "18px" },
//   stepItem:    { display: "flex", gap: "14px", alignItems: "flex-start" },
//   stepNumber:  { width: "24px", height: "24px", borderRadius: "50%", backgroundColor: "#f3f4f6", border: "1px solid #e5e7eb", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: "700", color: "#6b7280", flexShrink: 0, marginTop: "1px" },
//   stepContent: { display: "flex", flexDirection: "column", gap: "3px" },
//   stepTitle:   { fontSize: "13px", fontWeight: "600", color: "#111827" },
//   stepDesc:    { fontSize: "12px", color: "#9ca3af", lineHeight: "1.5", fontWeight: "400" },

//   formatNote: { display: "flex", alignItems: "center", gap: "7px", fontSize: "12px", color: "#9ca3af", fontWeight: "400", paddingTop: "4px", marginTop: "auto" },
//   formatDot:  { width: "5px", height: "5px", borderRadius: "50%", backgroundColor: "#d1d5db", flexShrink: 0 },
// };



// client/src/pages/payment/PaymentUploadPage.jsx

import React, { useEffect, useRef, useState } from "react";
import { uploadPayments } from "../../api/paymentApi";
import PaymentUploader from "../../components/payment/PaymentUploader";

// ── Required Excel columns — validated before upload ──────────────────────────
const REQUIRED_COLUMNS = [
  "Invoice Number",
  "Invoice Date",
  "Service Period",
  "Total Amount",
  "Payment Status",
  "Payment Date",
  "Payment Reference Number",
];

// ── Read Excel headers from the file on the client (no upload needed) ─────────
function readExcelHeaders(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        // Dynamically import xlsx from CDN is not available here,
        // so we do a lightweight header sniff using SheetJS if available,
        // otherwise resolve with null to skip client-side validation.
        if (typeof window !== "undefined" && window.XLSX) {
          const data     = new Uint8Array(e.target.result);
          const workbook = window.XLSX.read(data, { type: "array" });
          const sheet    = workbook.Sheets[workbook.SheetNames[0]];
          const rows     = window.XLSX.utils.sheet_to_json(sheet, { header: 1 });
          resolve(rows[0] || []);
        } else {
          resolve(null); // skip — SheetJS not loaded on client
        }
      } catch {
        resolve(null);
      }
    };
    reader.onerror = () => resolve(null);
    reader.readAsArrayBuffer(file);
  });
}

export default function PaymentUploadPage() {

  const [file, setFile]               = useState(null);
  const [result, setResult]           = useState(null);
  const [loading, setLoading]         = useState(false);
  const [uploaderKey, setUploaderKey] = useState(0);

  // Breakdown expand state
  const [showAlreadyPaid, setShowAlreadyPaid] = useState(false);
  const [showNotFound,    setShowNotFound]    = useState(false);
  const [showMismatch,    setShowMismatch]    = useState(false);

  // Inline validation error (missing columns)
  const [validationError, setValidationError] = useState(null);

  // Header scroll
  const [hidden, setHidden]     = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const lastY = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 8);
      if (y > lastY.current && y > 120) setHidden(true);
      else setHidden(false);
      lastY.current = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // ── When user picks a new file, validate columns immediately ────────────────
  const handleSetFile = async (f) => {
    setValidationError(null);
    setResult(null);
    setFile(f);

    if (!f) return;

    const headers = await readExcelHeaders(f);
    if (headers === null) return; // SheetJS not available — server will validate

    const missing = REQUIRED_COLUMNS.filter(
      (col) => !headers.map((h) => String(h).trim()).includes(col)
    );

    if (missing.length > 0) {
      setValidationError({
        type:    "missing_columns",
        missing,
        found:   headers,
      });
    }
  };

  // ── Process ──────────────────────────────────────────────────────────────────
  const handleProcess = async () => {
    if (!file) { alert("Please select a payment Excel file."); return; }

    // Block if client-side validation already found missing columns
    if (validationError) return;

    try {
      setLoading(true);
      setShowAlreadyPaid(false);
      setShowNotFound(false);
      setShowMismatch(false);

      const response = await uploadPayments(file);

      // ── Handle server-side missing-column error ──────────────────────
      if (response.error === "missing_columns" || response.missingColumns) {
        setValidationError({
          type:    "missing_columns",
          missing: response.missingColumns || [],
          found:   response.foundColumns   || [],
        });
        return;
      }

      // ── Fallback: derive typed arrays from old flat errors[] format ──
      if (!response.alreadyPaidInvoices && Array.isArray(response.errors)) {
        response.alreadyPaidInvoices = response.errors
          .filter((e) => e.reason === "Invoice already paid")
          .map((e) => ({ invoice_number: e.invoice_number, vendor: e.vendor || null, amount: e.amount || null, reason: e.reason }));
      }
      if (!response.notFoundInvoices && Array.isArray(response.errors)) {
        response.notFoundInvoices = response.errors
          .filter((e) => e.reason === "Invoice not found")
          .map((e) => ({ invoice_number: e.invoice_number, vendor: e.vendor || null, amount: e.amount || null, reason: e.reason }));
      }
      if (!response.mismatchInvoices && Array.isArray(response.errors)) {
        response.mismatchInvoices = response.errors
          .filter((e) => !["Invoice already paid", "Invoice not found"].includes(e.reason))
          .map((e) => ({ invoice_number: e.invoice_number, vendor: e.vendor || null, amount: e.amount || null, reason: e.reason }));
      }

      if (response.alreadyPaid === undefined)
        response.alreadyPaid = response.alreadyPaidInvoices?.length || 0;
      if (response.notFound === undefined)
        response.notFound = response.notFoundInvoices?.length || 0;
      if (response.mismatch === undefined)
        response.mismatch = response.mismatchInvoices?.length || 0;

      setResult(response);

    } catch (err) {
      console.error("Payment processing error:", err);
      // Show inline error instead of alert
      setValidationError({ type: "server_error", message: err?.response?.data?.error || "Payment processing failed. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setResult(null);
    setFile(null);
    setValidationError(null);
    setShowAlreadyPaid(false);
    setShowNotFound(false);
    setShowMismatch(false);
    setUploaderKey((k) => k + 1);
  };

  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div style={styles.page}>

      {/* ── HEADER ── */}
      <header style={{
        ...styles.header,
        ...(scrolled ? styles.headerScrolled : {}),
        ...(hidden   ? styles.headerHidden   : {}),
      }}>
        <div style={styles.headerInner}>
          <div style={styles.brand}>
            <div style={styles.logoWrap}>📤</div>
            <div>
              <div style={styles.brandTitle}>Upload Payments</div>
              <div style={styles.brandSubtitle}>Process and update invoice payment records</div>
            </div>
          </div>
        </div>
      </header>

      {/* ── MAIN ── */}
      <main style={styles.main}>

        <div style={styles.pageHeader}>
          <div style={styles.eyebrowRow}>
            <span style={styles.eyebrowDot} />
            <span style={styles.eyebrow}>Payments</span>
            <span style={styles.eyebrowSep}>/</span>
            <span style={styles.eyebrowMuted}>Upload</span>
          </div>
          <h1 style={styles.pageTitle}>Payment Upload</h1>
          <p style={styles.pageSubtitle}>
            Upload an Excel sheet to process and update invoice payment records in the database
          </p>
        </div>

        {/* ── VALIDATION ERROR BANNER ── */}
        {validationError && (
          <ValidationBanner
            error={validationError}
            onDismiss={() => setValidationError(null)}
          />
        )}

        <div style={styles.contentGrid}>

          {/* ── LEFT ── */}
          <PaymentUploader
            key={uploaderKey}
            file={file}
            setFile={handleSetFile}
            onProcess={handleProcess}
            loading={loading}
            hasError={!!validationError}
          />

          {/* ── RIGHT ── */}
          <div style={styles.sectionCard}>
            {result ? (
              <>
                {/* RESULT HEADER */}
                <div style={styles.sectionHeader}>
                  <div style={{ ...styles.sectionIconWrap, backgroundColor: "#dcfce7" }}>
                    <span style={styles.sectionIcon}>✅</span>
                  </div>
                  <div>
                    <div style={styles.sectionTitle}>Processing Complete</div>
                    <div style={styles.sectionSubtitle}>
                      {result.totalRows} row{result.totalRows !== 1 ? "s" : ""} processed from file
                    </div>
                  </div>
                </div>

                <div style={styles.divider} />

                {/* STAT BOXES */}
                <div style={styles.resultGrid}>
                  <StatBox value={result.totalRows}       label="Total Rows" />
                  <StatBox value={result.updatedInvoices} label="Updated"
                    valueColor="#15803d" bg="#f0fdf4" border="#bbf7d0" />
                  <StatBox value={result.alreadyPaid}     label="Already Paid"
                    valueColor="#b45309" bg="#fffbeb" border="#fde68a"
                    clickable={result.alreadyPaid > 0}
                    expanded={showAlreadyPaid}
                    onToggle={() => setShowAlreadyPaid((v) => !v)} />
                  <StatBox value={result.notFound}        label="Not Found"
                    valueColor="#dc2626" bg="#fef2f2" border="#fecaca"
                    clickable={result.notFound > 0}
                    expanded={showNotFound}
                    onToggle={() => setShowNotFound((v) => !v)} />
                </div>

                {/* MISMATCH STAT */}
                {result.mismatch > 0 && (
                  <StatBox value={result.mismatch} label="Mismatches"
                    valueColor="#7c3aed" bg="#f5f3ff" border="#ddd6fe"
                    clickable expanded={showMismatch}
                    onToggle={() => setShowMismatch((v) => !v)} />
                )}

                {/* ALREADY PAID TABLE */}
                {showAlreadyPaid && (
                  <BreakdownTable
                    title="Already Paid Invoices"
                    hint="Payment already recorded — these rows were skipped"
                    items={result.alreadyPaidInvoices || []}
                    accentColor="#b45309"
                    accentBg="#fffbeb"
                    accentBorder="#fde68a"
                    dotColor="#f59e0b"
                    tagLabel="Already Paid"
                    tagBg="#fef3c7"
                    tagColor="#92400e"
                    showReason={false}
                  />
                )}

                {/* NOT FOUND TABLE */}
                {showNotFound && (
                  <BreakdownTable
                    title="Not Found Invoices"
                    hint="Invoice number not matched in database"
                    items={result.notFoundInvoices || []}
                    accentColor="#dc2626"
                    accentBg="#fef2f2"
                    accentBorder="#fecaca"
                    dotColor="#ef4444"
                    tagLabel="Not Found"
                    tagBg="#fee2e2"
                    tagColor="#991b1b"
                    showReason={false}
                  />
                )}

                {/* MISMATCH TABLE */}
                {showMismatch && (
                  <BreakdownTable
                    title="Mismatch Details"
                    hint="Date, service period or amount did not match the database"
                    items={result.mismatchInvoices || []}
                    accentColor="#7c3aed"
                    accentBg="#f5f3ff"
                    accentBorder="#ddd6fe"
                    dotColor="#8b5cf6"
                    tagLabel="Mismatch"
                    tagBg="#ede9fe"
                    tagColor="#5b21b6"
                    showReason
                  />
                )}

                <div style={styles.divider} />

                <button style={styles.resetButton} onClick={handleReset}>
                  ← Upload Another File
                </button>
              </>
            ) : (
              <>
                <div style={styles.sectionHeader}>
                  <div style={{ ...styles.sectionIconWrap, backgroundColor: "#f5f3ff" }}>
                    <span style={styles.sectionIcon}>ℹ️</span>
                  </div>
                  <div>
                    <div style={styles.sectionTitle}>How It Works</div>
                    <div style={styles.sectionSubtitle}>What happens when you upload a file</div>
                  </div>
                </div>
                <div style={styles.divider} />
                <div style={styles.stepList}>
                  <Step n="1" title="File is read row by row"   desc="Each row is parsed for invoice number, date, amount and payment details" />
                  <Step n="2" title="Matched against database"  desc="Invoice number is looked up and details are verified before any update" />
                  <Step n="3" title="Payment record is saved"   desc="Payment date, reference number and status are updated in the database" />
                  <Step n="4" title="Summary is returned"       desc="You see how many records were updated, skipped or not found" />
                </div>
                <div style={styles.formatNote}>
                  <span style={styles.formatDot} />
                  Supported formats:{" "}
                  <strong style={{ color: "#374151" }}>.xlsx</strong> and{" "}
                  <strong style={{ color: "#374151" }}>.xls</strong>
                </div>
              </>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// VALIDATION BANNER
// ─────────────────────────────────────────────────────────────────────────────
function ValidationBanner({ error, onDismiss }) {
  if (error.type === "server_error") {
    return (
      <div style={bannerStyles.wrap}>
        <div style={bannerStyles.iconWrap}>
          <span style={{ fontSize: "16px" }}>🚫</span>
        </div>
        <div style={bannerStyles.body}>
          <div style={bannerStyles.title}>Processing Failed</div>
          <div style={bannerStyles.desc}>{error.message}</div>
        </div>
        <button style={bannerStyles.dismiss} onClick={onDismiss}>✕</button>
      </div>
    );
  }

  // missing_columns
  return (
    <div style={bannerStyles.wrap}>
      <div style={bannerStyles.iconWrap}>
        <span style={{ fontSize: "16px" }}>⚠️</span>
      </div>
      <div style={bannerStyles.body}>
        <div style={bannerStyles.title}>
          Invalid Excel Format — {error.missing.length} required column{error.missing.length !== 1 ? "s" : ""} missing
        </div>
        <div style={bannerStyles.desc}>
          This file cannot be processed. Please ensure your Excel sheet contains all required columns.
        </div>
        <div style={bannerStyles.columnGrid}>
          {REQUIRED_COLUMNS.map((col) => {
            const present = error.found
              ? error.found.map((h) => String(h).trim()).includes(col)
              : !error.missing.includes(col);
            return (
              <div key={col} style={{
                ...bannerStyles.colChip,
                backgroundColor: present ? "#f0fdf4" : "#fef2f2",
                borderColor:     present ? "#bbf7d0" : "#fecaca",
                color:           present ? "#15803d" : "#dc2626",
              }}>
                <span style={{ fontSize: "11px", marginRight: "4px" }}>
                  {present ? "✓" : "✕"}
                </span>
                {col}
              </div>
            );
          })}
        </div>
        <div style={bannerStyles.hint}>
          Found columns in your file:{" "}
          <span style={{ fontWeight: "600", color: "#374151" }}>
            {error.found?.length ? error.found.join(", ") : "none detected"}
          </span>
        </div>
      </div>
      <button style={bannerStyles.dismiss} onClick={onDismiss}>✕</button>
    </div>
  );
}

const bannerStyles = {
  wrap: {
    display: "flex", alignItems: "flex-start", gap: "14px",
    padding: "16px 20px",
    backgroundColor: "#fffbeb",
    border: "1px solid #fde68a",
    borderRadius: "10px",
    marginBottom: "20px",
    position: "relative",
  },
  iconWrap: {
    width: "36px", height: "36px", borderRadius: "8px",
    backgroundColor: "#fef3c7",
    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
  },
  body:  { flex: 1, display: "flex", flexDirection: "column", gap: "6px" },
  title: { fontSize: "13px", fontWeight: "700", color: "#92400e" },
  desc:  { fontSize: "12px", color: "#b45309", fontWeight: "400", lineHeight: "1.5" },
  hint:  { fontSize: "11px", color: "#9ca3af", marginTop: "4px" },
  columnGrid: {
    display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "6px",
  },
  colChip: {
    display: "flex", alignItems: "center",
    padding: "3px 10px", borderRadius: "4px",
    border: "1px solid", fontSize: "11px", fontWeight: "600",
  },
  dismiss: {
    background: "none", border: "none",
    color: "#d97706", fontSize: "14px",
    cursor: "pointer", padding: "2px",
    flexShrink: 0, alignSelf: "flex-start",
    lineHeight: 1,
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// BREAKDOWN TABLE  — scrollable, handles 200+ rows
// ─────────────────────────────────────────────────────────────────────────────
function BreakdownTable({
  title, hint, items,
  accentColor, accentBg, accentBorder, dotColor,
  tagLabel, tagBg, tagColor,
  showReason,
}) {
  const [search, setSearch] = useState("");

  const filtered = items.filter((item) => {
    const q = search.toLowerCase();
    return (
      !q ||
      String(item.invoice_number).toLowerCase().includes(q) ||
      String(item.vendor || "").toLowerCase().includes(q) ||
      String(item.reason || "").toLowerCase().includes(q)
    );
  });

  return (
    <div style={{ ...tStyles.wrap, backgroundColor: accentBg, borderColor: accentBorder }}>

      {/* Panel header */}
      <div style={tStyles.header}>
        <div style={tStyles.titleRow}>
          <span style={{ ...tStyles.dot, backgroundColor: dotColor }} />
          <span style={{ ...tStyles.title, color: accentColor }}>{title}</span>
          <span style={{ ...tStyles.badge, backgroundColor: tagBg, color: tagColor, borderColor: accentBorder }}>
            {items.length}
          </span>
        </div>
        <div style={tStyles.hint}>{hint}</div>
      </div>

      {/* Search — shown only when > 8 items */}
      {items.length > 8 && (
        <div style={tStyles.searchWrap}>
          <span style={tStyles.searchIcon}>🔎</span>
          <input
            type="text"
            placeholder="Search invoice number, vendor…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={tStyles.searchInput}
          />
          {search && (
            <button style={tStyles.searchClear} onClick={() => setSearch("")}>✕</button>
          )}
        </div>
      )}

      {/* Table */}
      <div style={tStyles.tableWrap}>
        <table style={tStyles.table}>
          <thead>
            <tr>
              <th style={tStyles.th}>#</th>
              <th style={tStyles.th}>Invoice Number</th>
              <th style={tStyles.th}>Vendor</th>
              {showReason && <th style={tStyles.th}>Reason</th>}
              <th style={tStyles.th}>Amount</th>
              <th style={tStyles.th}>Status</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan={showReason ? 6 : 5} style={tStyles.noMatch}>
                  No results for "{search}"
                </td>
              </tr>
            ) : (
              filtered.map((item, i) => (
                <tr key={i} style={i % 2 === 0 ? tStyles.trEven : tStyles.trOdd}>
                  <td style={tStyles.td}>
                    <span style={tStyles.rowNum}>{i + 1}</span>
                  </td>
                  <td style={tStyles.td}>
                    <span style={{ ...tStyles.invoiceChip, color: accentColor, borderColor: accentBorder }}>
                      {item.invoice_number || "—"}
                    </span>
                  </td>
                  <td style={tStyles.td}>
                    {item.vendor
                      ? <span style={tStyles.vendorChip}>{item.vendor}</span>
                      : <span style={tStyles.dash}>—</span>}
                  </td>
                  {showReason && (
                    <td style={tStyles.td}>
                      <span style={tStyles.reasonText}>{item.reason || "—"}</span>
                    </td>
                  )}
                  <td style={tStyles.td}>
                    {item.amount
                      ? <span style={tStyles.amountText}>₹{Number(item.amount).toLocaleString("en-IN")}</span>
                      : <span style={tStyles.dash}>—</span>}
                  </td>
                  <td style={tStyles.td}>
                    <span style={{ ...tStyles.statusTag, backgroundColor: tagBg, color: tagColor }}>
                      {tagLabel}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Footer count */}
      <div style={tStyles.footer}>
        {search
          ? `Showing ${filtered.length} of ${items.length} records`
          : `${items.length} record${items.length !== 1 ? "s" : ""} total`
        }
      </div>
    </div>
  );
}

const tStyles = {
  wrap: {
    border: "1px solid", borderRadius: "8px",
    overflow: "hidden",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  header: { padding: "12px 14px 10px", borderBottom: "1px solid rgba(0,0,0,0.06)" },
  titleRow: { display: "flex", alignItems: "center", gap: "8px", marginBottom: "3px" },
  dot:   { width: "7px", height: "7px", borderRadius: "50%", flexShrink: 0 },
  title: { fontSize: "13px", fontWeight: "700", letterSpacing: "-0.01em" },
  badge: {
    fontSize: "10px", fontWeight: "700",
    padding: "2px 7px", borderRadius: "999px",
    border: "1px solid", marginLeft: "2px",
  },
  hint: { fontSize: "11px", color: "#9ca3af", fontWeight: "400" },

  searchWrap: {
    position: "relative",
    display: "flex", alignItems: "center",
    padding: "8px 12px",
    borderBottom: "1px solid rgba(0,0,0,0.05)",
    backgroundColor: "#ffffff",
  },
  searchIcon:  { position: "absolute", left: "22px", fontSize: "12px", pointerEvents: "none" },
  searchInput: {
    width: "100%", height: "30px",
    paddingLeft: "28px", paddingRight: "28px",
    fontSize: "12px", color: "#111827",
    backgroundColor: "#f9fafb",
    border: "1px solid #e5e7eb", borderRadius: "6px",
    outline: "none", fontFamily: "inherit",
    boxSizing: "border-box",
  },
  searchClear: {
    position: "absolute", right: "20px",
    background: "none", border: "none",
    color: "#9ca3af", fontSize: "11px",
    cursor: "pointer", padding: "0",
  },

  tableWrap: {
    maxHeight: "320px",
    overflowY: "auto",
    scrollBehavior: "smooth",
    backgroundColor: "#ffffff",
  },
  table: { width: "100%", borderCollapse: "collapse", fontSize: "12px", minWidth: "500px" },

  th: {
    padding: "8px 12px",
    fontSize: "10px", fontWeight: "700",
    color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.07em",
    backgroundColor: "#f9fafb",
    borderBottom: "1px solid #f3f4f6",
    textAlign: "left",
    position: "sticky", top: 0, zIndex: 1,
    whiteSpace: "nowrap",
  },
  td:     { padding: "8px 12px", borderBottom: "1px solid #f9fafb", verticalAlign: "middle" },
  trEven: { backgroundColor: "#ffffff" },
  trOdd:  { backgroundColor: "#fafafa" },
  noMatch:{ padding: "20px", textAlign: "center", color: "#9ca3af", fontSize: "12px" },

  rowNum: { fontSize: "11px", color: "#d1d5db", fontWeight: "600" },
  invoiceChip: {
    fontFamily: "ui-monospace, 'SF Mono', Menlo, monospace",
    fontSize: "11px", fontWeight: "600",
    padding: "2px 7px", borderRadius: "4px",
    border: "1px solid", backgroundColor: "#ffffff",
    whiteSpace: "nowrap",
  },
  vendorChip: {
    fontSize: "11px", fontWeight: "600", color: "#374151",
    backgroundColor: "#f3f4f6", padding: "2px 7px", borderRadius: "4px",
  },
  reasonText: { fontSize: "11px", color: "#6b7280", fontStyle: "italic" },
  amountText: {
    fontFamily: "ui-monospace, 'SF Mono', Menlo, monospace",
    fontSize: "11px", fontWeight: "600", color: "#374151",
  },
  statusTag: {
    fontSize: "10px", fontWeight: "700",
    padding: "2px 8px", borderRadius: "999px",
    whiteSpace: "nowrap",
  },
  dash:   { color: "#d1d5db", fontSize: "12px" },
  footer: {
    padding: "8px 14px",
    fontSize: "11px", color: "#9ca3af",
    backgroundColor: "#fafafa",
    borderTop: "1px solid rgba(0,0,0,0.04)",
    fontFamily: "inherit",
  },
};

// ─────────────────────────────────────
// STAT BOX
// ─────────────────────────────────────
function StatBox({ value, label, valueColor="#111827", bg="#f9fafb", border="#f3f4f6", clickable=false, expanded=false, onToggle }) {
  return (
    <div
      style={{ ...styles.resultItem, backgroundColor: bg, borderColor: border, cursor: clickable ? "pointer" : "default" }}
      onClick={clickable ? onToggle : undefined}
    >
      <span style={{ ...styles.resultValue, color: valueColor }}>{value}</span>
      <span style={styles.resultLabel}>{label}</span>
      {clickable && value > 0 && (
        <span style={{ ...styles.resultToggle, color: valueColor }}>
          {expanded ? "▲ Hide details" : "▼ View details"}
        </span>
      )}
    </div>
  );
}

function Step({ n, title, desc }) {
  return (
    <div style={styles.stepItem}>
      <div style={styles.stepNumber}>{n}</div>
      <div style={styles.stepContent}>
        <div style={styles.stepTitle}>{title}</div>
        <div style={styles.stepDesc}>{desc}</div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────
// STYLES
// ─────────────────────────────────────
const styles = {
  page: { minHeight: "100vh", backgroundColor: "#f9fafb", fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" },
  header: { position: "fixed", top: 0, left: 0, right: 0, height: "56px", backgroundColor: "#0f172a", zIndex: 100, transition: "transform 0.25s ease, box-shadow 0.25s ease", display: "flex", alignItems: "center" },
  headerScrolled: { boxShadow: "0 1px 0 rgba(255,255,255,0.06)" },
  headerHidden:   { transform: "translateY(-100%)" },
  headerInner: { width: "100%", maxWidth: "1400px", margin: "0 auto", padding: "0 40px", display: "flex", alignItems: "center", justifyContent: "space-between", boxSizing: "border-box" },
  brand:         { display: "flex", alignItems: "center", gap: "12px" },
  logoWrap: { fontSize: "20px", width: "36px", height: "36px", backgroundColor: "rgba(255,255,255,0.08)", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" },
  brandTitle:    { fontSize: "14px", fontWeight: "700", color: "#ffffff", letterSpacing: "-0.01em" },
  brandSubtitle: { fontSize: "11px", color: "rgba(255,255,255,0.45)", fontWeight: "400", marginTop: "1px" },
  main: { paddingTop: "80px", paddingBottom: "60px", paddingLeft: "40px", paddingRight: "40px", maxWidth: "1400px", margin: "0 auto", boxSizing: "border-box", width: "100%" },
  pageHeader:   { marginBottom: "28px" },
  eyebrowRow:   { display: "flex", alignItems: "center", gap: "7px", marginBottom: "10px" },
  eyebrowDot:   { width: "6px", height: "6px", borderRadius: "50%", backgroundColor: "#6366f1", boxShadow: "0 0 0 3px rgba(99,102,241,0.15)" },
  eyebrow:      { fontSize: "11px", fontWeight: "700", color: "#4f46e5", letterSpacing: "0.07em", textTransform: "uppercase" },
  eyebrowSep:   { fontSize: "11px", color: "#d1d5db" },
  eyebrowMuted: { fontSize: "11px", fontWeight: "600", color: "#9ca3af", letterSpacing: "0.07em", textTransform: "uppercase" },
  pageTitle:    { fontSize: "18px", fontWeight: "700", color: "#111827", margin: 0, letterSpacing: "-0.01em" },
  pageSubtitle: { fontSize: "13px", color: "#6b7280", margin: "4px 0 0 0", fontWeight: "400" },
  contentGrid:  { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px", width: "100%", alignItems: "stretch" },
  sectionCard:  { backgroundColor: "#ffffff", border: "1px solid #e5e7eb", borderRadius: "10px", padding: "24px", display: "flex", flexDirection: "column", gap: "20px", boxSizing: "border-box", height: "100%" },
  sectionHeader:   { display: "flex", alignItems: "center", gap: "14px" },
  sectionIconWrap: { width: "40px", height: "40px", borderRadius: "8px", backgroundColor: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  sectionIcon:     { fontSize: "18px" },
  sectionTitle:    { fontSize: "14px", fontWeight: "700", color: "#111827", letterSpacing: "-0.01em" },
  sectionSubtitle: { fontSize: "12px", color: "#9ca3af", marginTop: "2px", fontWeight: "400" },
  divider: { height: "1px", backgroundColor: "#f3f4f6", margin: "0 -24px" },
  resultGrid:   { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "12px" },
  resultItem:   { display: "flex", flexDirection: "column", gap: "4px", padding: "16px", borderRadius: "8px", border: "1px solid #f3f4f6", transition: "box-shadow 0.15s" },
  resultValue:  { fontSize: "28px", fontWeight: "700", color: "#111827", letterSpacing: "-0.02em", lineHeight: 1 },
  resultLabel:  { fontSize: "11px", fontWeight: "600", color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.05em", marginTop: "4px" },
  resultToggle: { fontSize: "10px", fontWeight: "700", marginTop: "6px", letterSpacing: "0.02em", opacity: 0.7 },
  mismatchRow:   { display: "flex", alignItems: "center", gap: "10px", padding: "10px 14px", backgroundColor: "#fffbeb", border: "1px solid #fde68a", borderRadius: "6px" },
  mismatchBadge: { fontSize: "12px", fontWeight: "600", color: "#b45309", whiteSpace: "nowrap" },
  mismatchHint:  { fontSize: "12px", color: "#92400e", fontWeight: "400" },
  resetButton: { height: "34px", padding: "0 16px", fontSize: "12px", fontWeight: "600", color: "#374151", backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "6px", cursor: "pointer", alignSelf: "flex-start", transition: "background-color 0.15s" },
  stepList:    { display: "flex", flexDirection: "column", gap: "18px" },
  stepItem:    { display: "flex", gap: "14px", alignItems: "flex-start" },
  stepNumber:  { width: "24px", height: "24px", borderRadius: "50%", backgroundColor: "#f3f4f6", border: "1px solid #e5e7eb", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: "700", color: "#6b7280", flexShrink: 0, marginTop: "1px" },
  stepContent: { display: "flex", flexDirection: "column", gap: "3px" },
  stepTitle:   { fontSize: "13px", fontWeight: "600", color: "#111827" },
  stepDesc:    { fontSize: "12px", color: "#9ca3af", lineHeight: "1.5", fontWeight: "400" },
  formatNote: { display: "flex", alignItems: "center", gap: "7px", fontSize: "12px", color: "#9ca3af", fontWeight: "400", paddingTop: "4px", marginTop: "auto" },
  formatDot:  { width: "5px", height: "5px", borderRadius: "50%", backgroundColor: "#d1d5db", flexShrink: 0 },
};